import Vue from 'vue'
import App from './App.vue'
import router from './router'
import qs from 'qs';
import i18n from './i18n/i18n'
import store from './store'
import axios from 'axios';
import animated from 'animate.css'
import { Popover } from 'ant-design-vue';
//import { Menu } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import '@vant/touch-emulator';
//import { Menu, Submenu, MenuItem, MenuItemGroup } from 'element-ui';
import 'aos/dist/aos.css'
import AOS from 'aos/dist/aos.js'
import '@/assets/fonts/fonts.css';
//接口
// import { getNav } from '@/api/nav'  //导航数据接口
// import { footerData } from '@/api/footer'  //版权数据接口


//import "lib-flexible/flexible"       // 自适配
import FastClick from 'fastclick'    // 移动端30ms延迟

import { Form } from 'vant';
import { Button } from 'vant';
import { Field } from 'vant';
import { Toast } from 'vant';
import { Loading } from 'vant';
import { Icon } from 'vant';
// import { Tab, Tabs } from 'vant';
import { Image as VanImage } from 'vant';
import { NoticeBar } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Divider } from 'vant';
import { Pagination } from 'vant';

//Vant
Vue.use(Form);
Vue.use(Button);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Icon);
// Vue.use(Tab);
// Vue.use(Tabs);
Vue.use(VanImage);
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Divider);
Vue.use(Pagination);

// Vue.use(animated);

//Antd
Vue.use(Popover);

//初始化aos动画
Vue.use(AOS);
AOS.init({
	offset: 100,
	easing: 'fade-up',
	duration: 1000,
	aosOnce: true,
	//disable: 'mobile',
});

//Elementui
// Vue.use(Menu);
// Vue.use(Submenu);
// Vue.use(MenuItem);
// Vue.use(MenuItemGroup);

axios.defaults.withCredentials = true;
Vue.prototype.axios = axios;
//axios.defaults.baseURL = '/api';

Vue.config.productionTip = false

FastClick.attach(document.body);

router.beforeEach((to, from, next) => {
	let flag = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
	if(flag) {
		//移动端
		window.location.href = 'https://i-membrane.com/m/index.html';
		//window.location.replace("https://i-membrane.com/m/index.html");
	}else {
		//PC端
		//设置默认语言
		if(!sessionStorage.getItem('lang')){
			sessionStorage.setItem('lang', 'cn');
		}
		//设置标题
		document.title = to.meta.title;
		//设置关键词
		if(to.meta.content){
			let head = document.getElementsByTagName('head');
			let meta = document.createElement('meta');
			document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords);
			document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description);
			document.querySelector('meta[name="author"]').setAttribute('content', to.meta.content.author);
			meta.content = to.meta.content;
			head[0].appendChild(meta);
		}
		next();
	}
	//请求导航&版权
	// if(!sessionStorage.getItem('navData')) {
	// 	let query = {language: sessionStorage.getItem('lang'), };
	// 	getNav(query).then((res) => {
	// 		sessionStorage.setItem('navData', JSON.stringify(res.data));
	// 		footerData(query).then((res) => {
	// 			sessionStorage.setItem('footerData', JSON.stringify(res.data));
	// 			next();
	// 		});
	// 	});
	// }else{
	// 	next();
	// }
});

new Vue({
  router,
  store,
  render: h => h(App),
  i18n,
}).$mount('#app')
